import axios from 'axios';
import config from '../../assets/config.js';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from './authHeader.js';

const base_url =window.location.origin+"/";

export const saveCompanyProfile = createAsyncThunk(
    'save-company-profile',
    async (payload,{rejectWithValue}) => {
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Administrative/SaveCompanyProfile`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);